import React from 'react';
import * as moment from 'moment';
import './navbar.css'
import { Link } from "react-router-dom";

class Navbar extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        'richieste': 0,
        'soccorso': false
      };
    }
    componentDidMount() {
      const start_str = moment().format('YYYY-MM-DD') + " 00:01:00";
      const start = moment(start_str).toDate();
      let self = this;
      window.firebase.firestore().collection('sos')
        .where('report_datetime', '>', start)
        .onSnapshot(function(col) {
          if(!col.empty) { //Abbiamo delle richieste di soccorso
            self.setState({
              'richieste': col.docs.length,
              'soccorso': true
            });
          }
        })
    }
    logout() {
      window.firebase.auth().signOut();
    }
    render() {
      return (
        <nav className={"main-header navbar navbar-expand navbar-white navbar-light " + (this.state.soccorso ? 'soccorso' : '') }>
          <ul className="navbar-nav">
            <li className="nav-item">
              <a className="nav-link" data-widget="pushmenu" href="#"><i className="fa fa-bars"></i></a>
            </li>
          </ul>
          <Link to="/map">Ci sono {this.state.richieste} richieste di soccorso!</Link>
          <button id="logout" onClick={this.logout}>
            Logout
          </button>
        </nav>
      );
    }
  }
  
  export default Navbar;
  